import React, { useState } from 'react'
import BaseAppContainer from '../base--app-container/BaseAppContainer'
import LeftPanelMenu from '../left-panel-menu/LeftPanelMenu'
import Styles from "./AppleMusic.module.scss";

import { ReactComponent as AppleListenNow } from "../../icons/extra_icons/apple_listen_now.svg"
import { ReactComponent as AppleBrowse } from "../../icons/extra_icons/apple_browse.svg"
import { ReactComponent as AppleRadio } from "../../icons/extra_icons/apple_radio.svg"
import { ReactComponent as AppleIcon } from "../../icons/common/apple_logo.svg"
import MusicPage from './music-page/MusicPage'
import { APP_KEY_IDS } from '../../constants/constants';
import { getCurrentOption } from '../../global/functions/functrions';
import ListenNow from './listen-now/ListenNow';

const AppleMusic = () => {

    const leftMenuOptions = [
        {
            label:"Apple Music",
            options:[
                {
                    id: "0",
                    label: "Listen Now",
                    icon: <AppleListenNow width={20} height={20} />
                },
                {
                    id: "1",
                    label: "Browse",
                    icon: <AppleBrowse width={20} height={20} />
                },
                {
                    id: "2",
                    label: "Radio",
                    icon: <AppleRadio width={20} height={20} />
                },
            ]
        },
        {
            label:"Library",
            options:[
                {
                    id: "3",
                    label: "Albums",
                    icon: <AppleListenNow width={20} height={20} />
                },
                {
                    id: "4",
                    label: "Artists",
                    icon: <AppleBrowse width={20} height={20} />
                },
                {
                    id: "5",
                    label: "Songs",
                    icon: <AppleRadio width={20} height={20} />
                },
                {
                    id: "6",
                    label: "Music Videos",
                    icon: <AppleRadio width={20} height={20} />
                },
                {
                    id: "7",
                    label: "Made for You",
                    icon: <AppleRadio width={20} height={20} />
                },
            ]
        }, 
        {
            label:"Store",
            options:[
                {
                    id: "8",
                    label: "iTunes Store",
                    icon: <AppleListenNow width={20} height={20} />
                },
            ]
        },
        {
            label:"Playlists",
            options:[
            ]
        }
    ]
    const [activeOption, setActiveOption] = useState("0")
    const [activeLink, setActiveLink] = useState("")
    const browseSongs = [
        {
            label: "We Recommend",
            options: [
                {
                    id: "0",
                    title: "Acroos The SHeets",
                    subText: "Brett Young",
                    link: "https://embed.music.apple.com/us/album/across-the-sheets/1691613078",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/d5/04/10/d5041025-dbef-cea4-82aa-6200223aedbe/23BMR0004254.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "1",
                    title: "You Are Who You Hang Out Me",
                    subText: "The Front Bottoms",
                    link: "https://embed.music.apple.com/in/album/you-are-who-you-hang-out-with/1690376893",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/69/b8/3c/69b83cce-b3ed-b482-6c45-bc10375d79ff/075679690951.jpg/316x316bb.webp"
                },
                {
                    id: "2",
                    title: "Victory",
                    subText: "Clan Ducerot",
                    link: "https://embed.music.apple.com/us/album/victory/1681153436",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/36/5b/56/365b56c6-376a-9ed9-0849-b682322cf373/23UMGIM23690.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "3",
                    title: "danceXL",
                    subText: "Apple Music Dance",
                    link: "https://embed.music.apple.com/us/playlist/dancexl/pl.6bf4415b83ce4f3789614ac4c3675740",
                    coverImage: "https://is3-ssl.mzstatic.com/image/thumb/Features116/v4/cf/db/4f/cfdb4f5f-d3ba-da56-8163-7536aaa2dbe9/26cb6b4a-af55-49fc-b22c-bb497ea986b8.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "4",
                    title: "Superbloom",
                    subText: "Apple Music Pop",
                    link: "https://embed.music.apple.com/us/playlist/superbloom/pl.78ee237116dc46f1a5a3d8916b4a28fc",
                    coverImage: "https://is4-ssl.mzstatic.com/image/thumb/Features116/v4/5d/32/03/5d3203d9-9156-e97a-ac98-afc46d3b1e39/cbd81edb-0aed-4c9a-aa97-7521b173735f.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "5",
                    title: "#onRepeat",
                    subText: "Apple Music Hip-Hop",
                    link: "https://embed.music.apple.com/us/playlist/onrepeat/pl.426a1044619f47d6b1f86b3f79ecf857",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Features126/v4/c1/c0/5c/c1c05cfb-6738-bce2-a210-df582ccfaf89/d687ee89-8bf5-45e8-a50e-1b9aaac9e489.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "6",
                    title: "Breaking Dance",
                    subText: "Apple Music Dance",
                    link: "https://embed.music.apple.com/us/playlist/breaking-dance/pl.77a913605bba4a968c5cb2b93d87b2ca",
                    coverImage: "https://is2-ssl.mzstatic.com/image/thumb/Features115/v4/ed/fa/e2/edfae28c-4668-19b0-bb24-242ad3c094d2/U0MtTVMtV1ctQnJlYWtpbmdfRGFuY2VfRURNLUFEQU1fSUQ9MTEyNDU0MTA4My5wbmc.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "7",
                    title: "A List Pop",
                    subText: "Apple Music Pop",
                    link: "https://embed.music.apple.com/us/playlist/a-list-pop/pl.5ee8333dbe944d9f9151e97d92d1ead9",
                    coverImage: "https://is5-ssl.mzstatic.com/image/thumb/Features116/v4/f2/25/10/f22510d9-fedb-9df0-f177-a0e70d4f5f37/08ec69da-2027-4e0a-96f2-a53085902b91.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "8",
                    title: "Puro Pop",
                    subText: "Apple Music Pop Latino",
                    link: "https://embed.music.apple.com/us/playlist/puro-pop/pl.2754a2d6e0084e2b8106fcd35fef6492",
                    coverImage: "https://is5-ssl.mzstatic.com/image/thumb/Features126/v4/35/7d/ab/357dabca-ae21-62f2-6cd7-ee43aee12137/f4a98a9a-fcd6-464d-bcb4-612be7a1fb2b.png/316x316SC.DN01.webp?l=en-US"
                }
            ]
        },
        {
            label: "Now in Spatial Audio",
            options: [
                {
                    id: "0",
                    title: "AUSTIN(Bonus)",
                    subText: "Post Malone",
                    link: "https://embed.music.apple.com/us/album/austin-bonus/1699799646",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/09/0b/3f/090b3f53-818e-29bc-1331-94892dd3a935/23UMGIM50188.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "1",
                    title: "Beethoven: 9 Symphonies",
                    subText: "Berlin Philharmonic; Herbert won Karajan",
                    link: "https://embed.music.apple.com/us/album/beethoven-9-symphonies/1677635463",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/c2/70/2b/c2702b80-dede-7752-2e90-9382344444cf/22UMGIM52644.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "2",
                    title: "Mixmag Presents ANNA: In Session(DJ Mix)",
                    subText: "ANNA",
                    link: "https://embed.music.apple.com/us/album/mixmag-presents-anna-in-session-dj-mix/1684545053",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/b3/bf/f1/b3bff1be-9f9c-932f-a7a1-021c59033ac6/197188029067.jpg/316x316bb.webp"
                },
                {
                    id: "3",
                    title: "Collage(EP)",
                    subText: "The Chainsokers",
                    link: "https://embed.music.apple.com/us/album/whos-loving-you-ep/1690871869",
                    coverImage: "https://is5-ssl.mzstatic.com/image/thumb/Music116/v4/50/a9/0f/50a90fcd-87bb-f34a-b786-93f92294a3bf/23UMGIM61425.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "4",
                    title: "Memories... Do not open",
                    subText: "The Chainsokers",
                    link: "https://embed.music.apple.com/us/album/%C3%A1tta/1689744202",
                    coverImage: "https://is5-ssl.mzstatic.com/image/thumb/Music116/v4/56/2a/6e/562a6e96-956d-4697-f5c4-9e18e6a3ed17/4050538920437.jpg/316x316bb.webp"
                },
                {
                    id: "5",
                    title: "John Wick",
                    subText: "Chapter 1 Album",
                    link: "https://embed.music.apple.com/us/album/the-world-ep-2-outlaw/1691699403",
                    coverImage: "https://is4-ssl.mzstatic.com/image/thumb/Music126/v4/ac/6a/9a/ac6a9abc-47cf-a4b9-a979-7bd5d4266ea0/196871212342.jpg/316x316bb.webp"
                },
                {
                    id: "6",
                    title: "World of Walker",
                    subText: "Alan Walker",
                    link: "https://embed.music.apple.com/us/playlist/pop-in-spatial-audio/pl.cc74a5aec23942da9cf083c6c4344aee",
                    coverImage: "https://is4-ssl.mzstatic.com/image/thumb/Features125/v4/6a/98/05/6a9805ff-e07e-b752-4e04-ea4eb91e8f26/U0MtTVMtV1ctUG9wLUFEQU1fSUQ9MTU2MDE4MDQxMC5wbmc.png/316x316cc.webp"
                },
                {
                    id: "7",
                    title: "Heligoland",
                    subText: "Massive Attack",
                    link: "https://embed.music.apple.com/us/album/the-outlaw-side-of-me/1684506165",
                    coverImage: "https://is2-ssl.mzstatic.com/image/thumb/Music126/v4/6a/45/83/6a4583de-e1a1-2aa9-667b-9ed4df949439/23BMR0004124.rgb.jpg/316x316bb.webp"
                },
                {
                    id: "8",
                    title: "After Hours",
                    subText: "The Weekend",
                    link: "https://embed.music.apple.com/us/playlist/r-b-in-spatial-audio/pl.cdcd503ccbd6484ba11687f034f14a62",
                    coverImage: "https://is4-ssl.mzstatic.com/image/thumb/Features126/v4/91/2f/34/912f34ad-a000-5f92-35e8-eeb49ab08eb1/6d4a5d85-a1fb-4861-affe-c4a411e8504e.png/316x316cc.webp"
                },
                {
                    id: "9",
                    title: "After Hours",
                    subText: "The Weekend",
                    link: "https://embed.music.apple.com/us/album/a-gift-a-curse/1692838126",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/82/29/76/822976d1-f1db-6626-e2f7-55343995ecd9/075679678485.jpg/316x316bb.webp"
                },
            ]
        },
        {
            label: "Just Ask Siri",
            options: [
                {
                    id: "0",
                    title: "Hanging With Friends",
                    subText: "'Hey Siri, play the Hanging With Friends playlist'",
                    link: "https://embed.music.apple.com/us/playlist/hanging-with-friends/pl.66371da439504101a7ef4975d482e443",
                    coverImage: "https://is3-ssl.mzstatic.com/image/thumb/Features125/v4/3b/23/46/3b2346d8-3ed6-9546-339e-96d58b327545/U0MtTVMtVEVSLVNvY2lhbF9IYW5naW5nV2l0aEZyaWVuZHMtQURBTV9JRD0xNTc0NzUxMzU0LnBuZw.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "1",
                    title: "Dinner Party",
                    subText: "'Hey Siri, play the Dinner Party playlist'",
                    link: "https://embed.music.apple.com/us/playlist/dinner-party/pl.dc86ddc3b40a43eda4819c4149112016",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/98/7d/f8/987df8b0-c761-b5da-f0c3-b844988cb47a/U0MtTVMtVEVSLVBhcnR5X0Rpbm5lclBhcnR5LUFEQU1fSUQ9MTU3NTExMTE5Mi5wbmc.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "2",
                    title: "After the Spa",
                    subText: "'Hey Siri, play the After the Spa playlist'",
                    link: "https://embed.music.apple.com/us/playlist/after-the-spa/pl.e7d9ecc7b3754af3be55cbe36d835894",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/e7/3c/31/e73c3123-c8f9-795e-0a09-151840ae49ee/U0MtTVMtV1ctQWZ0ZXJ0aGVTcGEtQURBTV9JRD0xNTc1MTcxODA0LnBuZw.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "3",
                    title: "Getting ready to go Out",
                    subText: "'Hey Siri, play the Getting ready to go Out playlist'",
                    link: "https://embed.music.apple.com/us/playlist/getting-ready-to-go-out/pl.8da7c1c485674217b2e0f223d645b3ea",
                    coverImage: "https://is4-ssl.mzstatic.com/image/thumb/Features125/v4/17/8d/f5/178df5ae-179e-7d63-1cf7-fb4118d76a9b/U0MtTVMtVEVSLVBhcnR5X0dldHRpbmdSZWFkeVRvR29PdXQtQURBTV9JRD0xNTc1OTYwODUyLnBuZw.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "4",
                    title: "Samba Lessons",
                    subText: "'Hey Siri, play the Samba Lessons playlist'",
                    link: "https://embed.music.apple.com/us/playlist/samba-lessons/pl.a5095e14b41c4c7a83ef23ac96b1b2f8",
                    coverImage: "https://is3-ssl.mzstatic.com/image/thumb/Features125/v4/1a/19/8d/1a198d8b-f1ff-9dfe-155c-3b3749afcdb9/U0MtTVMtVEVSLVNvY2lhbF9TYW1iYUxlc3NvbnMtQURBTV9JRD0xNTc1OTIxMjYyLnBuZw.png/316x316SC.DN01.webp?l=en-US"
                },
                {
                    id: "5",
                    title: "Escape from Reality",
                    subText: "'Hey Siri, play the Escape from Reality playlist'",
                    link: "https://embed.music.apple.com/us/playlist/escape-from-reality/pl.52b3459761ff4326a7be3485bfff55e6",
                    coverImage: "https://is3-ssl.mzstatic.com/image/thumb/Features115/v4/9d/5d/08/9d5d08bd-f72c-4fe5-20ce-4d0c56d11448/U0MtTVMtVEVSLVdlbGxuZXNzX0VzY2FwZUZyb21SZWFsaXR5LUFEQU1fSUQ9MTU3NTk2MTM4NC5wbmc.png/316x316SC.DN01.webp?l=en-US"
                }
            ]
        }
    ]
    
    const radioSongs = [
        {
            label: "City Charts",
            layoutType:"banner",
            options: [
                {
                    id: "0",
                    title: "Dinner After Party",
                    subText: "Apple Music Pop",
                    link: "https://embed.music.apple.com/in/playlist/dinner-party-essentials/pl.6a236667fbc046a49b48ea9cf4e8b639",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/4e/d5/1d/4ed51df9-7a04-e2fe-daec-2ddc68b02444/U0MtTVMtV1ctRGlubmVyX1BhcnR5X0Vzc2VudGlhbHMtQURBTV9JRD0xMTg0MDY5NDg3LnBuZw.png/316x316SC.CAESS02.webp?l=en-GB"

                },
                {
                    id: "1",
                    title: "Classical DInner Party",
                    subText: "Apple Music Classical",
                    link: "https://embed.music.apple.com/in/playlist/classical-dinner-party/pl.c738441110654ba0902577359937517c",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/f6/a6/7d/f6a67db6-95b0-6709-5263-3bc11b7929a0/U0MtTVMtV1ctQ2xhc3NpY2FsX0Rpbm5lcl9QYXJ0eS1BREFNX0lEPTk5MTQ1MTAxOS5wbmc.png/316x316SC.DNC01.webp?l=en-GB"

                },
                {
                    id: "2",
                    title: "Brown Suger",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/brown-sugar/pl.9e1d81be9a3a4a93af47734543cdd3a0",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/04/2b/b0/042bb0b7-66ce-9c22-93c6-8a6cfba55105/U0MtTVMtV1ctQnJvd25fU3VnYXItQURBTV9JRD0xMzc2OTk0NDg3LnBuZw.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "3",
                    title: "Smooth &and Easy",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/smooth-and-easy/pl.e48b617799b44f85bb6aab2ff753f3bf",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/1b/38/70/1b3870f3-34aa-88e5-f072-992d0cb31a48/U0MtTVMtV1ctU21vb3RoX2FuZF9FYXN5LUFEQU1fSUQ9OTkxNDAwNDczLnBuZw.png/316x316SC.DN01.webp?"
                },
                {
                    id: "4",
                    title: "Mood",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/mood/pl.daa2a689923d4562bf5650a96809f929",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/68/7a/9b/687a9b00-57d3-5dd1-a3e8-0de41f3a2dd2/U0MtTVMtV1ctTW9vZC1BREFNX0lEPTk5NjY1MTM3OC5wbmc.png/316x316SC.DN01.webp?l=en-GB"
                }
            ]
        },
        {
            label: "Our Special Radio Picks",
            layoutType:"inline",
            options: [
                {
                    id: "0",
                    title: "Beneath the Stars",
                    subText: "Apple Music India",
                    link: "https://embed.music.apple.com/in/playlist/beneath-the-stars/pl.cd1e46899e31421285d7e655bac51cbd",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features116/v4/80/c1/3e/80c13e63-d966-7ea0-e84c-9086894e8027/fa95015e-0b62-49cd-a050-aab8fc1d5151.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "1",
                    title: "Always Sunday",
                    subText: "Apple Music Chill",
                    link: "https://embed.music.apple.com/in/playlist/always-sunday/pl.401b996cbcda4861ae8da67b8cd3ff32",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/6c/86/5d/6c865dc6-bc4a-4a6e-a1ff-9bcbc6329052/U0MtTVMtV1ctQWx3YXlzX1N1bmRheS1BREFNX0lEPTE0MjE2NDEzMDMucG5n.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "2",
                    title: "Indie + Chill",
                    subText: "Apple Music India",
                    link: "https://embed.music.apple.com/in/playlist/indie-chill/pl.c4074df0f3114c7d9572859645229d75",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/e0/60/08/e06008a2-30de-c61a-a495-4438c4ffa2b6/U0MtTVMtV1ctaW5kaWVfK19jaGlsbC1BREFNX0lEPTE0MjE2NDA2ODUucG5n.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "3",
                    title: "Jazz Sunrise",
                    subText: "Apple Music Jazz",
                    link: "https://embed.music.apple.com/in/playlist/jazz-sunrise/pl.7829118459014cc18282086efda91458",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features122/v4/13/fb/02/13fb0267-f1f2-0635-c36a-152e835de4e2/56b39a5a-91b5-415d-99e2-2d00a6e91b35.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "4",
                    title: "Jazz Sunrise",
                    subText: "Apple Music Jazz",
                    link: "https://embed.music.apple.com/in/playlist/speakin-easy/pl.6492d1e3a5a1423fa15540046fc67771",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/a0/14/15/a0141524-98c7-b2e0-d7fa-090e58ae592b/U0MtTVMtV1ctU3BlYWtpbl9FYXN5LUFEQU1fSUQ9MTQyNjA1NDEwOS5wbmc.png/316x316SC.DN01.webp?l=en-GB"
                },
            ]
        },
        {
            label: "Top Radio Picks",
            layoutType:"inline",
            options: [
                {
                    id: "0",
                    title: "Dinner After Party",
                    subText: "Apple Music Pop",
                    link: "https://embed.music.apple.com/in/playlist/dinner-party-essentials/pl.6a236667fbc046a49b48ea9cf4e8b639",
                    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/4e/d5/1d/4ed51df9-7a04-e2fe-daec-2ddc68b02444/U0MtTVMtV1ctRGlubmVyX1BhcnR5X0Vzc2VudGlhbHMtQURBTV9JRD0xMTg0MDY5NDg3LnBuZw.png/316x316SC.CAESS02.webp?l=en-GB"

                },
                {
                    id: "1",
                    title: "Classical DInner Party",
                    subText: "Apple Music Classical",
                    link: "https://embed.music.apple.com/in/playlist/classical-dinner-party/pl.c738441110654ba0902577359937517c",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/f6/a6/7d/f6a67db6-95b0-6709-5263-3bc11b7929a0/U0MtTVMtV1ctQ2xhc3NpY2FsX0Rpbm5lcl9QYXJ0eS1BREFNX0lEPTk5MTQ1MTAxOS5wbmc.png/316x316SC.DNC01.webp?l=en-GB"

                },
                {
                    id: "2",
                    title: "Brown Suger",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/brown-sugar/pl.9e1d81be9a3a4a93af47734543cdd3a0",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/04/2b/b0/042bb0b7-66ce-9c22-93c6-8a6cfba55105/U0MtTVMtV1ctQnJvd25fU3VnYXItQURBTV9JRD0xMzc2OTk0NDg3LnBuZw.png/316x316SC.DN01.webp?l=en-GB"
                },
                {
                    id: "3",
                    title: "Smooth &and Easy",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/smooth-and-easy/pl.e48b617799b44f85bb6aab2ff753f3bf",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features115/v4/1b/38/70/1b3870f3-34aa-88e5-f072-992d0cb31a48/U0MtTVMtV1ctU21vb3RoX2FuZF9FYXN5LUFEQU1fSUQ9OTkxNDAwNDczLnBuZw.png/316x316SC.DN01.webp?"
                },
                {
                    id: "4",
                    title: "Mood",
                    subText: "Apple Music R&B",
                    link: "https://embed.music.apple.com/in/playlist/mood/pl.daa2a689923d4562bf5650a96809f929",
                    coverImage:"https://is1-ssl.mzstatic.com/image/thumb/Features125/v4/68/7a/9b/687a9b00-57d3-5dd1-a3e8-0de41f3a2dd2/U0MtTVMtV1ctTW9vZC1BREFNX0lEPTk5NjY1MTM3OC5wbmc.png/316x316SC.DN01.webp?l=en-GB"
                }
            ]
        },
    ]


    const openAppleMusic=()=>{
        window.open("https://applemusic.com")
    }

    const getMainScreen = () => {
        if (activeLink) {
            return <div className={Styles.frame_conta}>
                <iframe className={Styles.frame} allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" width={"595px"} height="450px" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src={activeLink}></iframe>
            </div>
        }
        else {

            switch (getCurrentOption(activeOption)) {
                case "0": return <ListenNow/>
                case "1": return <div className={Styles.page}><MusicPage content={browseSongs} onAlbumCoverClick={setActiveLink}/> </div> 
                case "2": return <div className={Styles.page}><MusicPage layoutType='inline' content={radioSongs} onAlbumCoverClick={setActiveLink}/> </div> 
                default:return (
                    <div className={Styles.default_page}>
                        <div className={Styles.apple_logo}>
                            <AppleIcon/>
                        </div>
                        <div className={Styles.label}>
                            Listen more music on applemusic.com
                        </div>
                        <button className={Styles.cta} onClick={openAppleMusic}>
                            Visit
                        </button>
                    </div>
                )
            }
        }
    }

    return (
        <BaseAppContainer
        loadFromX={40}
            appId={APP_KEY_IDS.MUSIC}
            title={""}
            width={900}
            height={525}
            SideBar={<LeftPanelMenu menuContent={leftMenuOptions} activeValue={activeOption} handleOptionClick={setActiveOption} onSuccessfulSubmission={()=>{setActiveLink("")}}/>}
            MainScreen={
                <div className={Styles.container}>
                    {getMainScreen()}
                </div>
            }
        />
    )
}

export default AppleMusic

